import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const PersonalReferencesDropdown = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 8px;
  background: ${colors.white};
  margin-top: 30px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  display: flex;
  flex-direction: column;
  height: ${prop => prop.open ? 'auto' : '52px'};
  overflow: ${prop => prop.open ? 'none' : 'hidden'};

  svg {
    transform: ${prop => prop.open ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }
`;

export const PersonalReferencesDropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const PersonalReferencesDropdownBody = styled.div`
  
`;
